import { render } from "./detail.vue?vue&type=template&id=0412f28c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=0412f28c&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0412f28c"]])

export default __exports__